const React = require('react');

const UpsellPlaceholder = () => (
  <li className="card-grid__item">
    <div className="product-card">
      <div className="product-card-img-container">
        <div className="placeholder-image size-card"></div>
      </div>
      <div className="product-card-description">
        <div className="placeholder-p mb-half "></div>
        <div className="product-card__price">
          <div className="placeholder-p quarter-width "></div>
        </div>
      </div>
    </div>
  </li>
);

module.exports = UpsellPlaceholder;



// WEBPACK FOOTER //
// ./javascripts/components/product_show_page/upsell_placeholder.jsx